import React, {useEffect, useState} from 'react';

import {browserHistory, withRouter, WithRouterProps} from 'react-router';

import {convertLocationParamsFoldersDocumentsToFetchParams} from 'app/documents/actions';
import {fetchFolderDetails} from 'app/folders/actions';
import {useFolders} from 'app/folders/api';
import {EditFolder} from 'app/folders/components/dashboards/EditFolder';
import {FolderItem} from 'app/folders/components/FolderItem';
import {getFilterLink} from 'app/general/dashboards/DashboardFilterbar';
import {KBTreeDeleteItemContextProvider} from 'app/kbs/components/KBEditPage/KBTree/KBTreeDeleteItemModal';
import {KBTreeEditItemContextProvider} from 'app/kbs/components/KBEditPage/KBTree/KBTreeEditItemModal';
import {gt} from 'app/utils/i18n';

import {DashboardSidebarCollapsableList} from './DashboardSidebarCollapsableList';

import type {ProceduresDashboardLocationParamsType} from 'app/procedures/types';
import type {
  FolderRecurrentParentSerializedType,
  FolderSerializedType,
} from 'sweet-types';

type OwnProps = {
  item: FolderSerializedType;
};
type RouterProps = WithRouterProps<ProceduresDashboardLocationParamsType>;
type Props = OwnProps & RouterProps;
const FolderItemWrap = withRouter<Props>(({item, location}: Props) => {
  const [selectedFolder, setSelectedFolder] = useState<
    FolderRecurrentParentSerializedType | undefined
  >(undefined);
  const [fetchingDetails, setFetchingDetails] = useState<boolean>(false);
  useEffect(() => {
    if (!fetchingDetails && location.query.folder != null) {
      setFetchingDetails(true);
      fetchFolderDetails(location.query.folder).then(
        (folder: FolderRecurrentParentSerializedType) => {
          setSelectedFolder(folder);
          setFetchingDetails(false);
        }
      );
    } else if (location.query.folder == null) {
      setSelectedFolder(undefined);
    }
  }, [location.query.folder]);

  const onToggle = (expanded: boolean, folder: FolderSerializedType) => {
    const link = getFilterLink(
      browserHistory,
      browserHistory.getCurrentLocation(),
      {
        folder:
          folder.hashid === selectedFolder?.hashid ? undefined : folder.hashid,
      }
    );
    browserHistory.push(link);
  };

  return (
    <FolderItem
      folder={item}
      selectedHashid={location.query.folder}
      selectedFolder={selectedFolder}
      tooltipText={gt('Only procedures in this folder will be displayed')}
      isParentDirty={false}
      isHidingDocuments={true}
      isHidingCreateDocument={true}
      isHidingCreateFolder={false}
      isCreateFolderPopup={true}
      isHidingTeams={true}
      afterAction={() => Promise.resolve(true)}
      onToggle={onToggle}
    />
  );
});

export const DashboardSidebarFoldersList = () => {
  return (
    <KBTreeEditItemContextProvider FormComponent={EditFolder}>
      <KBTreeDeleteItemContextProvider>
        <DashboardSidebarCollapsableList
          icon="fa-folder"
          title={gt('Folders')}
          reduxKey="folders"
          watchModelChange="folder"
          showSearch={false}
          noResultsMessage={gt('No folders.')}
          canCreate={false}
          createLink={''}
          searchPlaceholder={gt('Search folders...')}
          useDataHook={useFolders}
          paramsConverter={convertLocationParamsFoldersDocumentsToFetchParams}
          pageParam={'folders_page'}
          ItemComponent={FolderItemWrap}
          itemNameProcessor={(item) => item.name}
        />
      </KBTreeDeleteItemContextProvider>
    </KBTreeEditItemContextProvider>
  );
};
